module.exports = __webpack_public_path__ + "img/logo-picpay.0b493189.png";